export default "__VITE_ASSET__EDXuBFbz__"